import { useHistory } from "react-router-dom";

import BuildingLogo from "./icons/buildingLogo";

import {
  PageWrapper,
  PageTitle,
  OtherBanksWrapper,
  OtherBanksContent,
  OtherBankHeaderWrapper,
  LogoWrapper,
  OtherBankDescriptionWrapper,
  WithOtherBank,
  WithOtherBankDesc,
  ChooseBank,
  BankWrapper,
  BankRadioInputsWrapper,
  BankContent,
  LogoAndNameWrapper,
  BankName,
  RadioInput,
  ProcreditBankWrapper,
  ProcreditBankContent,
  ProcrditLogoAndNameWrapper,
  WithProcreditWrapper,
  WithProcredit,
  WithProcreditDesc,
} from "./style";
import { useTranslation } from "react-i18next";
import ProcreditLogo from "./icons/procreditLogo";
import NavButton from "../common/button";
import { FormWrapper } from "../Identification/verifyIdentity/styles";
import { useForm } from "react-hook-form";
import {
  getErrorMessage,
  handleIdentificationStepChange,
  redirectToPiOnboardingIdentification,
} from "../helpers";
import { useMutation, useQuery } from "@tanstack/react-query";
import { beginKeepzOnboarding, getVendors } from "../../../../API/PIservices";
import { ONBOARDING_SESSION_TYPE_ID } from "../constants";
import {
  BANKS,
  IDENTOMAT_CODE,
  KEEPZ_CODE,
  ONBOARDING_TYPE,
} from "./constants";
import Error from "../Identification/verifyIdentity/Modals/Error";
import { useState } from "react";
import { startIdentOnboarding } from "../../../../API/common/sharedServices";
import { SERVICE_TYPES } from "../../../../utils/constants/fieldErrors";

function ChooseVerificationMethod({
  onboardingSessionTypeId = ONBOARDING_SESSION_TYPE_ID.piOnboarding,
}) {
  const isLoanApplication =
    onboardingSessionTypeId === ONBOARDING_SESSION_TYPE_ID.loanApplication;
  const { t, i18n } = useTranslation();
  const { register, handleSubmit, watch } = useForm();
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState(null);

  const bankValue = watch("bank");
  const searchParams = new URLSearchParams(window.location.search);
  const hideProcredit =
    searchParams.get("onboarding-type") === String(ONBOARDING_TYPE.onlyKeepz);

  const { data: vendors, isLoading: isVendorsLoading } = useQuery({
    queryKey: ["termsAgreement", i18n.language],
    queryFn: getVendors,
    select: (res) => res?.data,
    retry: false,
  });

  const { isPending, mutate: handleBeginKeepzOnboarding } = useMutation({
    mutationFn: (bankCode) => {
      return beginKeepzOnboarding({ bankCode });
    },
    onSuccess: () => {
      handleIdentificationStepChange("confirm-code", history, [
        ["bank-code", bankValue],
      ]);
    },
    onError: (err) => {
      setErrorMessage(getErrorMessage(err));
    },
  });

  const { isPending: isAuthProcessing, mutate: handleGetAuthLink } =
    useMutation({
      mutationFn: startIdentOnboarding,
      onSuccess: (res) => {
        sessionStorage.setItem("localToken", res?.data?.localToken);
        sessionStorage.setItem(
          "servicetype",
          isLoanApplication ? SERVICE_TYPES.loanApplication : SERVICE_TYPES.PIForm
        );
        sessionStorage.setItem("redirectUrl", res?.data?.redirectUrl);

        window.location.href = `/Identomat/${i18n.language}`;
      },
      onError: (err) => {
        setErrorMessage(getErrorMessage(err));
      },
    });

  function handleProcreditClick() {
    if (isPending) return;
    handleGetAuthLink();
  }

  function onSubmit(data) {
    if (!data?.bank) return;

    if (data.bank !== IDENTOMAT_CODE) {
      handleBeginKeepzOnboarding(data.bank);
    } else {
      handleProcreditClick();
    }
  }
  const otherBanks = vendors
    ? vendors?.find((item) => item?.code === KEEPZ_CODE)
    : [];

  const procredit = vendors
    ? vendors?.find((item) => item?.code === IDENTOMAT_CODE)
    : [];

  if (isVendorsLoading) {
    return null;
  }

  const showProcredit = !hideProcredit && procredit;

  return (
    <PageWrapper>
      <Error
        errorMessage={errorMessage}
        close={() => {
          setErrorMessage(null);
        }}
      />

      <FormWrapper onSubmit={handleSubmit(onSubmit)}>
        <PageTitle>{t("choose_verification_method")}</PageTitle>

        {otherBanks?.banks?.length ? (
          <OtherBanksWrapper>
            <OtherBanksContent>
              <OtherBankHeaderWrapper>
                <LogoWrapper radius={12} padding={8}>
                  <BuildingLogo />
                </LogoWrapper>
                <OtherBankDescriptionWrapper>
                  <WithOtherBank>{t("another_bank")}</WithOtherBank>
                  <WithOtherBankDesc>
                    {t("another_bank_desc")}
                  </WithOtherBankDesc>
                </OtherBankDescriptionWrapper>
              </OtherBankHeaderWrapper>

              <ChooseBank>{t("choose_bank")}</ChooseBank>

              <BankRadioInputsWrapper>
                {otherBanks?.banks?.map((item) => {
                  return (
                    <BankWrapper key={item?.code}>
                      <BankContent>
                        <LogoAndNameWrapper>
                          <LogoWrapper radius={6} padding={6}>
                            {BANKS?.[item?.code]?.logo}
                          </LogoWrapper>
                          <BankName>{item?.name}</BankName>
                        </LogoAndNameWrapper>

                        <RadioInput
                          type="radio"
                          {...register("bank")}
                          value={item?.code}
                        />
                      </BankContent>
                    </BankWrapper>
                  );
                })}
              </BankRadioInputsWrapper>
            </OtherBanksContent>
          </OtherBanksWrapper>
        ) : null}

        {showProcredit ? (
          <ProcreditBankWrapper>
            <ProcreditBankContent>
              <ProcrditLogoAndNameWrapper>
                <LogoWrapper radius={6} padding={6}>
                  <ProcreditLogo />
                </LogoWrapper>
                <WithProcreditWrapper>
                  <WithProcredit>{t("with_procredit")}</WithProcredit>
                  <WithProcreditDesc>
                    {t("with_procredit_desc")}
                  </WithProcreditDesc>
                </WithProcreditWrapper>
              </ProcrditLogoAndNameWrapper>

              <RadioInput
                type="radio"
                {...register("bank")}
                value={procredit?.code}
              />
            </ProcreditBankContent>
          </ProcreditBankWrapper>
        ) : null}

        <NavButton
          showPrevButton
          handlePrev={(e) => {
            if (isAuthProcessing || isPending) return;
            e.preventDefault();
            redirectToPiOnboardingIdentification();
          }}
          disabled={!bankValue || isPending || isAuthProcessing}
        />
      </FormWrapper>
    </PageWrapper>
  );
}

export default ChooseVerificationMethod;
